




























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import axios from 'axios';
import { mapState } from 'vuex';
import userService from '@/services/hub/user';
import Helpers from '@/utils/Helpers';
import md5 from 'crypto-js/md5';
import { registerLog } from '@/services/hub/logsAction';
import jwtDecode from 'jwt-decode';
import AppHeader from '../components/AppHeader.vue';

export default Vue.extend({
  name: 'ViewUploads',
  components: {
    AppHeader,
  },
  data() {
    return {
      folder: '',
      interval: null as number | null,
      value: 0,
      uploadProgress: 0,
      conversionsProgress: {} as any,
      uploadingVideo: [] as any,
      queueVideos: 0 as any,
      isDragging: false,
      fileInputValue: [],
      activeTab: null,
      uploadedVideos: [] as any,
      tableHeaders: [
        { text: '', value: '' },
        { text: 'name', value: 'name' },
        { text: 'duration', value: 'duration' },
        { text: 'send_date', value: 'send_date' },
        { text: 'size', value: 'size' },
        { text: ' ', value: '' },
      ],
      smTableHeaders: [
        { text: '', value: '' },
        { text: 'name', value: 'name' },
        { text: 'size', value: 'size' },
        { text: '  ', value: '' },
      ],
      allUploadedVideos: [],
      allVideos: [] as any,
      searchUpload: '',
      sortField: 'date',
      sortOrder: 'desc',

      uploadedDict: {} as any,
      remainingVideos: 0 as any,
      listVideoConversion: [] as any,
      errorSocket: [] as any,
      failedSocket: [] as any,
      completedSocket: null,
      socket: null as any,
      listVideoConversionTest: [] as any,
      customerPlansId: 0 as any,
      secretPlayer: '',
      playerCopy: false,
      planOdId: 0,
      userToken: '',
      folders: [] as any,
      selectedFolder: null as any,
      folderMain: null as any,
      videoQueue: [] as any[],
      pendingVideos: [] as any[],
      currentUploadingIndex: -1,
      uploadComplete: '' as any,
      videosAwaitConversion: [] as any,
      videosConverting: [] as any,
      videosError: [] as any,
      videosConverted: [] as any,
      cancelTokenSource: null as any,
      id_customer: 0,
      username: '',
      videoUploadName: '',
      shownToasts: {} as Record<string, boolean>,
      isGetAllVideosRunning: false,
      lastGetAllVideosCall: 0,
      debounceTimers: {} as Record<string, number | null>,
      currentFolderParent: null as number | null,
      folderStack: [] as any[],
      uploadInProgress: false,
      currentUploadingFile: null,
      progressFetchTimer: null as NodeJS.Timeout | null,
      smoothProgressTimers: {} as any,
      lastProgressUpdate: {} as Record<string, number>,
      estimatedConversionTime: {} as Record<string, number>,
      progressInterpolation: {} as Record<string, any>,
      // Sistema de watching para vídeos em conversão
      watchingTimer: null as NodeJS.Timeout | null,
      isWatchingRunning: false,
      lastWatchingCall: 0,
      watchingInterval: 10000 as any, // 10 segundos
      videoHashesToMonitor: [] as string[],
      videoMonitoringIntervals: {} as Record<string, NodeJS.Timeout>,
    };
  },
  computed: mapState(['user', 'secret']),
  watch: {
    uploadedVideos: 'updateAllVideos',
    uploadingVideo: 'updateAllVideos',
  },
  beforeDestroy() {
    if (this.interval !== null) {
      clearInterval(this.interval);
    }

    // Parar sistema de watching
    this.stopWatching();

    // Limpar todos os timers de progresso fluído
    Object.keys(this.smoothProgressTimers).forEach((videoId: string) => {
      if (this.smoothProgressTimers[videoId]) {
        clearInterval(this.smoothProgressTimers[videoId]);
      }
    });

    // Limpar timers de busca de progresso
    if (this.progressFetchTimer) {
      clearInterval(this.progressFetchTimer);
    }
  },
  async mounted() {
    await this.userInformation();
    await this.getGallerySelect();

    // Buscar todos os vídeos do plano que estão convertendo ao entrar na tela
    await this.getAllConvertingVideosForPlan();

    // Agora apenas monitoramos os hashes dos vídeos que acabaram de fazer upload
    console.log('🔄 Sistema modificado - usando apenas monitoramento por hash');
  },
  methods: {
    async userInformation() {
      const userInfo = localStorage.getItem('user') as any;
      const user = JSON.parse(userInfo);

      const { token } = user;
      const decodedToken = jwtDecode(token) as any;
      this.username = decodedToken.sub.nickname;
      this.id_customer = decodedToken.sub.id_customers;
      this.customerPlansId = user.user.plan_id;
      this.userToken = user.token;
      await this.getPlanOd(this.customerPlansId);
      await this.getAllVideos();
      await this.getCustomerPlan(this.planOdId);
      await this.getGallerySelect();
    },
    isVideoFromToday(video: any) {
      if (!video || !video.created_date) return true; // Se não tem data, mostrar mesmo assim

      const videoDate = new Date(video.created_date);
      const today = new Date();

      // Se o vídeo está convertendo, sempre mostrar independente da data
      if (video.status === 'CONVERTING' || video.status === 'converting') {
        return true;
      }

      return (
        videoDate.getDate() === today.getDate()
        && videoDate.getMonth() === today.getMonth()
        && videoDate.getFullYear() === today.getFullYear()
      );
    },
    showToast(key: string, type: string) {
      const text = this.$t(key);
      this.$store.dispatch('notification/create', {
        text,
        type,
      });
    },
    async logUserAction(action: string, status: string, description: string) {
      try {
        const logData = {
          id_customers: this.id_customer,
          username: this.username,
          action,
          status,
          description,
        };

        await registerLog(logData);
      } catch (error) {
        // Erro ao registrar o log
      }
    },
    async uploadVideo(event: any) {
      const files = Array.from(event);

      // Add files to pending videos to show in UI
      files.forEach((file: any) => {
        this.pendingVideos.push({
          name: file.name,
          size: this.formatFileSize(file.size),
          status: 'pending',
        });
      });

      this.queueVideos += files.length;
      files.forEach((file, index) => {
        this.videoQueue.push({ file, index });
      });

      // If no upload is in progress, start the upload process
      if (this.uploadingVideo.length === 0 && this.uploadProgress === 0) {
        this.processNextVideoInQueue();
      }
    },
    getRandomInteger(minimum: number, maximum: number) {
      return Math.floor(Math.random() * (maximum - minimum + 1)) + minimum;
    },
    getRandomString(length: number) {
      const date = new Date();
      const randomStrings = [];
      const characters = 'abcdefghijklmnopqrstuvwxyz0123456789'.concat(
        date.getFullYear() as any,
        date.getMonth() as any,
        date.getDate() as any,
        date.getHours() as any,
        date.getHours() as any,
        date.getMinutes() as any,
        date.getSeconds() as any,
      );
      const maximum = characters.length - 1;

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < length; ++i) {
        randomStrings.push(characters[this.getRandomInteger(0, maximum)]);
      }

      return randomStrings.join('');
    },

    // ==============================================================
    // FUNÇÕES DE UPLOAD S3 (UPLOAD DIRETO - SEM CHUNKS)
    // ==============================================================

    /**
     * Iniciar upload S3 e obter URL presignada
     */
    async initMultipartUpload(file: File, videoHash: string, gallery: string) {
      // UPLOAD DIRETO: enviar arquivo inteiro de uma vez (totalParts = 1)
      const fileSize = file.size;
      const CHUNK_SIZE = fileSize; // Usar tamanho total do arquivo
      const totalParts = 1; // Sempre 1 parte (upload direto)

      console.log('📁 Arquivo:', file.name);
      console.log('📊 Tamanho:', fileSize, 'bytes');
      console.log('🚀 Modo: UPLOAD DIRETO (arquivo completo de uma vez)');
      console.log('🔑 Video Hash:', videoHash);

      const apiUrl = process.env.VUE_APP_HUB_API_URL;
      const response = await axios.post(
        `${apiUrl}/api/upload/multipart/s3`,
        {
          video_hash: videoHash,
          fileName: file.name,
          fileSize,
          chunkSize: CHUNK_SIZE,
          totalParts,
          customerId: this.planOdId.toString(),
          clientType: 'vod',
          origin: 'HUB2',
          gallery,
        },
        {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
            'Content-Type': 'application/json',
          },
        },
      );

      const { uploadId, objectName, presignedUrls } = response.data;

      if (!uploadId || !objectName) {
        throw new Error('Erro ao iniciar upload: uploadId ou objectName não retornados');
      }

      console.log('✅ Upload iniciado com sucesso!');
      console.log('   Upload ID:', uploadId);
      console.log('   Object Name:', objectName);

      return {
        uploadId,
        objectName,
        presignedUrls,
        chunkSize: CHUNK_SIZE,
        totalParts,
      };
    },

    /**
     * Upload do arquivo completo usando URL presignada (upload direto)
     */
    async uploadChunks(
      file: File,
      presignedUrls: any[],
      chunkSize: number,
      totalParts: number,
      cancelToken: any,
    ) {
      const etags: Array<{ PartNumber: number; ETag: string }> = [];

      console.log('📤 Fazendo upload direto do arquivo completo...');

      // Como totalParts é sempre 1, apenas fazemos upload do arquivo inteiro
      const presignedData = presignedUrls[0];
      if (!presignedData || !presignedData.url) {
        throw new Error('URL presignada não encontrada');
      }

      console.log(`   Enviando arquivo completo (${this.formatFileSize(file.size)})...`);

      // Upload do arquivo completo direto para S3
      const response = await axios.put(presignedData.url, file, {
        headers: {
          'Content-Type': file.type || 'video/mp4',
        },
        cancelToken, // Adicionar suporte ao cancelamento
        onUploadProgress: (progressEvent) => {
          // Calcular progresso do upload
          const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          this.uploadProgress = percentage;
        },
      });

      // Extrair ETag do header
      const etag = response.headers.etag || response.headers.ETag;
      if (!etag) {
        throw new Error('ETag não retornado');
      }

      // Remover aspas do ETag se necessário
      const cleanETag = etag.replace(/"/g, '');

      etags.push({
        PartNumber: 1,
        ETag: cleanETag,
      });

      console.log(`   ✅ Upload completo! (ETag: ${cleanETag.substring(0, 10)}...)`);

      return etags;
    },

    /**
     * Completar o multipart upload
     */
    async completeMultipartUpload(
      file: File,
      videoHash: string,
      uploadId: string,
      objectName: string,
      etags: Array<{ PartNumber: number; ETag: string }>,
      gallery: string,
    ) {
      console.log('🏁 Finalizando upload...');

      const apiUrl = process.env.VUE_APP_HUB_API_URL;
      const response = await axios.post(
        `${apiUrl}/api/upload/multipart/complete`,
        {
          client_id: `vod_${this.planOdId}`,
          filename: file.name,
          size: file.size,
          video_hash: videoHash,
          objectName,
          uploadId,
          gallery,
          origin: 'HUB2',
          parts: etags,
        },
        {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
            'Content-Type': 'application/json',
          },
        },
      );

      // eslint-disable-next-line object-curly-newline
      const { status, hash, id, jobId, downloadUrls } = response.data;

      if (status !== 'success') {
        throw new Error('Erro ao completar upload');
      }

      console.log('');
      console.log('✅ ✅ ✅ UPLOAD COMPLETADO COM SUCESSO! ✅ ✅ ✅');
      console.log('');
      console.log('📋 Informações do Upload:');
      console.log('   • Video Hash:', hash);
      console.log('   • Upload ID (DB):', id);
      console.log('   • Job ID:', jobId);
      console.log('   • Download URL (Primary):', downloadUrls?.primary);
      console.log('   • Download URL (Backup):', downloadUrls?.backup);
      console.log('');
      console.log('🎬 O vídeo está sendo processado!');

      return response.data;
    },

    /**
     * Função principal que orquestra todo o processo de upload S3 (direto, sem chunks)
     */
    async uploadVideoS3Multipart(file: File, videoHash: string, gallery: string) {
      try {
        // Criar cancel token para permitir cancelamento
        this.cancelTokenSource = axios.CancelToken.source();
        // PASSO 1: Iniciar upload e obter URL presignada
        // eslint-disable-next-line max-len, object-curly-newline
        const { uploadId, objectName, presignedUrls, chunkSize, totalParts } = await this.initMultipartUpload(
          file,
          videoHash,
          gallery,
        );

        // PASSO 2: Upload direto do arquivo completo
        const etags = await this.uploadChunks(
          file,
          presignedUrls,
          chunkSize,
          totalParts,
          this.cancelTokenSource.token,
        );

        // PASSO 3: Completar upload e registrar no banco
        const result = await this.completeMultipartUpload(
          file,
          videoHash,
          uploadId,
          objectName,
          etags,
          gallery,
        );

        return result;
      } catch (error) {
        // Verificar se foi cancelado pelo usuário
        if (axios.isCancel(error)) {
          console.log('⚠️ Upload cancelado pelo usuário');
          throw new Error('Upload canceled by the user.');
        }
        console.error('❌ Erro no upload S3:', error);
        throw error;
      }
    },

    // ==============================================================
    // FIM DAS FUNÇÕES DE UPLOAD S3
    // ==============================================================

    async processNextVideoInQueue() {
      try {
        if (this.videoQueue.length === 0) {
          this.currentUploadingIndex = -1;
          this.uploadInProgress = false;
          this.currentUploadingFile = null;
          return;
        }

        const { file, index } = this.videoQueue[0];
        this.videoQueue.shift();

        // Find the index in pendingVideos
        const pendingIndex = this.pendingVideos.findIndex((v) => v.name === file.name);

        // Remove from pendingVideos immediately when upload starts
        if (pendingIndex !== -1) {
          this.pendingVideos.splice(pendingIndex, 1);
        }

        this.uploadingVideo = [file];
        this.videoUploadName = file.name;
        this.uploadInProgress = true;
        this.currentUploadingFile = file.name;

        // Gerar hash único para o vídeo
        const videoHash = this.getRandomString(15);

        // Check if folders are properly loaded
        if (!this.selectedFolder && !this.folderMain) {
          // Wait for folders to load if they haven't yet
          await this.getGallerySelect();
          if (!this.folderMain) {
            throw new Error(
              'No destination folder available. Please try again or contact support.',
            );
          }
        }

        // Safe access to folder ID with fallback
        const folderSelected = this.selectedFolder?.id || this.folderMain?.id || null;

        if (!folderSelected) {
          throw new Error(
            'No destination folder selected. Please select a folder before uploading.',
          );
        }

        // ==============================================================
        // UPLOAD VIA S3 (DIRETO - ARQUIVO COMPLETO)
        // ==============================================================
        await this.uploadVideoS3Multipart(file, videoHash, folderSelected);

        this.queueVideos -= 1;
        this.showToast('video_uploaded_successfully', 'success');
        const description = `Upload do video ${file.name} feito com sucesso.`;
        await this.logUserAction('Creation', 'Success', description);

        // Adicionar hash do vídeo para monitoramento
        this.videoHashesToMonitor.push(videoHash);

        // SETAR STATUS AWAIT_CONVERSION NO FRONTEND IMEDIATAMENTE
        const videoData = {
          id: videoHash,
          name: file.name, // Usar nome real do arquivo
          hash: videoHash,
          status: 'AWAIT_CONVERSION',
          progress: 100,
          progressConverting: 0,
          message: 'Aguardando início da conversão',
          created_date: new Date().toISOString(), // Adicionar data de criação
        };

        // Adicionar vídeo diretamente na lista de aguardando conversão
        this.videosAwaitConversion.push(videoData);

        // Iniciar monitoramento do status do vídeo
        this.startVideoStatusMonitoring(videoHash);

        this.uploadComplete = true;

        // Reset for next upload
        this.uploadingVideo = [];
        this.uploadProgress = 0;
        this.currentUploadingIndex = -1;
        this.uploadInProgress = false;
        this.currentUploadingFile = null;

        // Process next video in queue if any
        if (this.videoQueue.length > 0) {
          // Small delay between uploads
          setTimeout(() => {
            this.processNextVideoInQueue();
          }, 1000);
        }
      } catch (err) {
        const error = err as Error;

        // Only show error if it's not a cancellation
        if (!axios.isCancel(err)) {
          this.showToast('video_uploaded_error', 'error');
          const description = `Erro no upload do video ${this.videoUploadName}: ${error.message
            || 'Erro desconhecido'}`;
          await this.logUserAction('Creation', 'Error', description);
        }

        // Reset for next upload
        this.uploadingVideo = [];
        this.uploadProgress = 0;
        this.currentUploadingIndex = -1;
        this.uploadInProgress = false;
        this.currentUploadingFile = null;

        // Continue with next video regardless of error
        if (this.videoQueue.length > 0) {
          setTimeout(() => {
            this.processNextVideoInQueue();
          }, 1000);
        }

        this.getAllVideos();
      }
    },
    cancelUpload() {
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel('Upload canceled by the user.');
      }
      this.uploadProgress = 0;
      this.uploadingVideo = [];
      this.uploadInProgress = false;
      this.currentUploadingFile = null;

      // eslint-disable-next-line max-len
      // Instead of clearing everything, just reduce queueVideos by 1 and continue with next video in queue
      if (this.queueVideos > 0) {
        this.queueVideos -= 1;
      }

      // Process next video in queue if there are any
      if (this.videoQueue.length > 0) {
        // Allow a small delay before starting the next upload
        setTimeout(() => {
          this.processNextVideoInQueue();
        }, 1000);
      } else {
        this.currentUploadingIndex = -1;
      }
    },
    async removeUpload(event: any, id: any) {
      try {
        event.preventDefault();
        event.stopPropagation();
        const apiUrl = process.env.VUE_APP_SOCKETIO_UPLOAD_URL;
        const response = await axios.put(
          `${apiUrl}confirmNotification/${id}`,
          { videoId: id },
          {
            headers: {
              Application: this.planOdId,
              Authorization: md5(`${this.planOdId}_JMV`),
            },
          },
        );
        this.videosConverting = [];
        this.videosError = [];
        this.showToast('Video removed successfully', 'success');
      } catch (error) {
        try {
          event.preventDefault();
          event.stopPropagation();
          const apiUrl = process.env.VUE_APP_SOCKETIO_UPLOAD_URL;
          const response = await axios.put(
            `${apiUrl}confirmNotification/${id}`,
            { videoId: id },
            {
              headers: {
                Application: this.planOdId,
                Authorization: md5(`${this.planOdId}_JMV`),
              },
            },
          );
          this.videosConverting = [];
          this.videosError = [];
          this.showToast('Video removed successfully', 'success');
        } catch (errorRetry) {
          this.showToast('Error when trying to remove video', 'error');
        }
      }
    },
    async retryUpload(event: any, id: any) {
      event.preventDefault();
      event.stopPropagation();
      try {
        const apiUrl = process.env.VUE_APP_SOCKETIO_UPLOAD_URL;
        const response = await axios.put(
          `${apiUrl}retryJob/${id}`,
          { jobId: id },
          {
            headers: {
              Application: this.planOdId,
              Authorization: md5(`${this.planOdId}_JMV`),
            },
          },
        );
        this.videosConverting = [];
        this.videosError = [];
        this.showToast('Video restaurado com sucesso', 'success');
      } catch (error) {
        try {
          const apiUrl = process.env.VUE_APP_SOCKETIO_UPLOAD_URL;
          const response = await axios.put(
            `${apiUrl}retryJob/${id}`,
            { jobId: id },
            {
              headers: {
                Application: this.planOdId,
                Authorization: md5(`${this.planOdId}_JMV`),
              },
            },
          );
          this.videosConverting = [];
          this.videosError = [];
          this.showToast('Video restaurado com sucesso', 'success');
        } catch (errorRetry) {
          this.showToast(
            'Error when trying to restart the conversion, please try again later',
            'error',
          );
        }
      }
    },
    async getCustomerPlan(id: string | number) {
      const response = await userService.getCustomerPlan(id);
      this.secretPlayer = response.data.data.secret;
    },
    formatFileSize(size: any) {
      if (size === 0) return '0 B';

      const units = ['B', 'KB', 'MB', 'GB', 'TB'];
      // eslint-disable-next-line radix
      const i = Math.floor(Math.log(size) / Math.log(1024));
      // eslint-disable-next-line no-restricted-properties
      return `${Math.round((size / Math.pow(1024, i)) * 100) / 100} ${units[i]}`;
    },
    formatFileSendDate(date: any) {
      if (date instanceof Date) {
        const options: Intl.DateTimeFormatOptions = {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
        };
        const formatted = date.toLocaleDateString('pt-br', options);
        return formatted;
      }
      const formatDate = new Date(date);
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      };
      const formatted = formatDate.toLocaleDateString('pt-br', options);
      return formatted;
    },
    handleDragOver(event: DragEvent) {
      event.preventDefault();
      this.isDragging = true;
    },
    handleDrop(event: any) {
      event.preventDefault();
      this.isDragging = false;

      const { files } = event.dataTransfer;
      if (files) {
        this.uploadVideo(files);
        this.resetFileInput();
      }
    },
    // eslint-disable-next-line consistent-return
    async getAllVideos(forceUpdate = false) {
      const now = Date.now();
      const minInterval = 5000; // 5 segundos

      // Ignorar chamadas frequentes demais a menos que seja forceUpdate
      if (
        !forceUpdate
        && (this.isGetAllVideosRunning || now - this.lastGetAllVideosCall < minInterval)
      ) {
        return Promise.resolve();
      }

      this.isGetAllVideosRunning = true;
      this.lastGetAllVideosCall = now;

      try {
        console.log('🔄 getAllVideos modificado - usando apenas monitoramento por hash');

        // Não buscamos mais todos os vídeos do plano
        // Apenas monitoramos os hashes dos vídeos que acabaram de fazer upload
        if (this.videoHashesToMonitor.length > 0) {
          console.log(`🔍 Monitorando ${this.videoHashesToMonitor.length} vídeos por hash...`);
          await this.monitorVideoStatus(this.videoHashesToMonitor);
        }
      } catch (error) {
        console.error('Erro ao monitorar vídeos por hash:', error);
      } finally {
        this.isGetAllVideosRunning = false;
      }
    },
    // eslint-disable-next-line consistent-return
    formatTime(time: any) {
      if (typeof time === 'string') {
        const date = time;
        return date.split('.')[0];
      }
    },
    updateAllVideos() {
      this.allVideos = [...this.uploadingVideo, ...this.uploadedVideos];
    },
    resetFileInput() {
      setTimeout(() => {
        this.fileInputValue = [];
      }, 4000);
    },
    // eslint-disable-next-line consistent-return
    confirmExit(event: any) {
      if (this.uploadProgress !== 0) {
        const confirmationMessage = 'Are you sure you want to quit?';

        event.preventDefault();
        // eslint-disable-next-line no-param-reassign
        event.returnValue = confirmationMessage;

        return confirmationMessage;
      }
    },
    mountVideos(videos: any, clearList = false) {
      if (clearList) {
        this.listVideoConversion = [];
        this.videosAwaitConversion = [];
        this.videosConverting = [];
        this.videosError = [];
        this.videosConverted = [];
      }

      if (!Array.isArray(videos) || videos.length === 0) {
        return;
      }

      videos.forEach((video: any) => {
        if ('remaining' in video) {
          return;
        }

        // Check if video already exists in any of our lists
        const alreadyInConverting = this.videosConverting.some((v: any) => v.id === video.id);
        const alreadyInAwaiting = this.videosAwaitConversion.some((v: any) => v.id === video.id);
        const alreadyInError = this.videosError.some((v: any) => v.id === video.id);
        const alreadyInCompleted = this.videosConverted.some((v: any) => v.id === video.id);

        // If video already exists in one of our lists, skip it (unless status has changed)
        if (
          (video.status === 'CONVERTING' && alreadyInConverting)
          || (video.status === 'AWAIT_CONVERSION' && alreadyInAwaiting)
          || (video.status === 'ERROR' && alreadyInError)
          || (video.status === 'COMPLETED' && alreadyInCompleted)
        ) {
          return;
        }

        // Create video data object with all necessary properties
        const videoData = {
          id: video.id,
          isConversionByFTP: video.upload_method === 'FTP',
          message: '',
          name: video.name,
          progress: 100,
          progressConverting: this.conversionsProgress[video.id] || 0,
          status: video.status,
          hash: video.hash || '',
          autoplay: video.autoplay === 1 || video.autoplay === true ? 1 : 0,
        };

        // Determinar status baseado no job status e video status
        const jobStatus = video.status?.toLowerCase();
        const videoStatus = video.video_status?.toLowerCase();

        // Se o vídeo está COMPLETED, sempre mostrar como convertido
        if (videoStatus === 'completed') {
          // Remove from other lists
          this.videosConverting = this.videosConverting.filter((v: any) => v.id !== video.id);
          this.videosAwaitConversion = this.videosAwaitConversion.filter(
            (v: any) => v.id !== video.id,
          );
          this.videosError = this.videosError.filter((v: any) => v.id !== video.id);

          // Add to completed list
          if (!alreadyInCompleted) {
            this.videosConverted.push(videoData);
            this.listVideoConversion.push(videoData);
          }
          // eslint-disable-next-line brace-style
        }
        // Se o job está em PROCESSING ou CONVERTING, mostrar como convertendo
        else if (jobStatus === 'processing' || jobStatus === 'converting') {
          // Remove from other lists
          this.videosAwaitConversion = this.videosAwaitConversion.filter(
            (v: any) => v.id !== video.id,
          );
          this.videosError = this.videosError.filter((v: any) => v.id !== video.id);
          this.videosConverted = this.videosConverted.filter((v: any) => v.id !== video.id);

          // Add to converting list
          if (!alreadyInConverting) {
            this.videosConverting.push(videoData);
            this.listVideoConversion.push(videoData);

            // Iniciar progresso fluído
            this.startSmoothProgress(video.id, video.progress || 0);
          }
          // eslint-disable-next-line brace-style
        }
        // Se o job está PENDING, mostrar como aguardando conversão
        else if (jobStatus === 'pending') {
          // Remove from other lists
          this.videosConverting = this.videosConverting.filter((v: any) => v.id !== video.id);
          this.videosError = this.videosError.filter((v: any) => v.id !== video.id);
          this.videosConverted = this.videosConverted.filter((v: any) => v.id !== video.id);

          // Add to awaiting list
          if (!alreadyInAwaiting) {
            this.videosAwaitConversion.push(videoData);
            this.listVideoConversion.push(videoData);
          }
          // eslint-disable-next-line brace-style
        }
        // Se há erro, mostrar como erro
        else if (jobStatus === 'error' || videoStatus === 'error') {
          // Remove from other lists
          this.videosConverting = this.videosConverting.filter((v: any) => v.id !== video.id);
          this.videosAwaitConversion = this.videosAwaitConversion.filter(
            (v: any) => v.id !== video.id,
          );
          this.videosConverted = this.videosConverted.filter((v: any) => v.id !== video.id);

          // Add to error list
          if (!alreadyInError) {
            this.videosError.push(videoData);
            this.listVideoConversion.push(videoData);
          }
        }

        // Store hash for the video if available
        if (video.hash) {
          this.uploadedDict[video.name] = { hash: video.hash };
        }
      });
    },

    // Métodos WebSocket removidos - agora usamos apenas API REST
    onClickVisualize(hash: string) {
      const env = process.env.VUE_APP_ENV || 'production';

      let baseUrl;
      if (env === 'sandbox') {
        baseUrl = 'https://player-sandbox.jmvstream.com/';
      } else if (env === 'staging') {
        baseUrl = 'https://player-staging.jmvstream.com/';
      } else {
        baseUrl = 'https://player.jmvstream.com/';
      }

      const videoUrl = `${baseUrl}${this.secretPlayer}/${hash}`;
      window.open(videoUrl, '_blank');
    },
    onClickVisualizeConversion(id: any) {
      const env = process.env.VUE_APP_ENV || 'production';

      // Verificar se secretPlayer está disponível
      if (!this.secretPlayer) {
        console.error('secretPlayer não está disponível');
        this.showToast('Player configuration not loaded', 'error');
        return;
      }

      // Buscar o vídeo na lista de vídeos em conversão
      // Tentar buscar por ID primeiro, depois por hash
      let videoConverting = this.videosConverting.find(
        (video: any) => Number(video.id) === Number(id),
      ) as any;

      // Se não encontrou por ID, tentar buscar por hash
      if (!videoConverting) {
        videoConverting = this.videosConverting.find((video: any) => video.hash === id) as any;
      }

      if (!videoConverting) {
        console.error(`Vídeo com ID/Hash ${id} não encontrado na lista de conversão`);
        console.log('Vídeos em conversão:', this.videosConverting);
        this.showToast('Video not found', 'error');
        return;
      }

      if (!videoConverting.hash) {
        console.error(`Hash do vídeo ${id} não encontrado`);
        this.showToast('Video hash not found', 'error');
        return;
      }

      let baseUrl;
      if (env === 'sandbox') {
        baseUrl = 'https://player-sandbox.jmvstream.com/';
      } else if (env === 'staging') {
        baseUrl = 'https://player-staging.jmvstream.com/';
      } else {
        baseUrl = 'https://player.jmvstream.com/';
      }

      const videoUrl = `${baseUrl}${this.secretPlayer}/${videoConverting.hash}`;
      console.log('Abrindo URL:', videoUrl);
      window.open(videoUrl, '_blank');
    },
    async onClickCopyIframe(hash: string, autoplay: any) {
      const env = process.env.VUE_APP_ENV || 'production';

      let baseUrl;
      if (env === 'sandbox') {
        baseUrl = 'https://player-sandbox.jmvstream.com/';
      } else if (env === 'staging') {
        baseUrl = 'https://player-staging.jmvstream.com/';
      } else {
        baseUrl = 'https://player.jmvstream.com/';
      }

      const videoUrl = `${baseUrl}${this.secretPlayer}/${hash}`;

      // Garantir que autoplay tenha um valor válido
      const autoplayValue = autoplay === 1 || autoplay === true ? 'autoplay; fullscreen' : 'fullscreen';

      const iframeCode = String.prototype.concat(
        '<iframe ',
        `allow="${autoplayValue}" `,
        'allowfullscreen ',
        'class="jmvplayer" ',
        'frameborder="0" ',
        `src="${videoUrl}" `,
        'width="640" height="360"></iframe>',
      );

      try {
        await Helpers.copyToClipboard(iframeCode);
        const index = this.allVideos.findIndex((video: any) => video.hash === hash);
        if (index !== -1) {
          this.$set(this.allVideos, index, { ...this.allVideos[index], showCopySuccess: true });
          setTimeout(() => {
            this.$set(this.allVideos, index, { ...this.allVideos[index], showCopySuccess: false });
          }, 3000);
        }
        this.showToast('iframe_copied_successfully', 'success');
      } catch (err) {
        const error = err as Error;
        console.error(`Erro ao copiar para a área de transferência: ${error.message}`);
        this.showToast('error_copying_to_clipboard', 'error');
      }
    },
    async onClickCopyIframeConversion(id: any) {
      const env = process.env.VUE_APP_ENV || 'production';

      // Verificar se secretPlayer está disponível
      if (!this.secretPlayer) {
        console.error('secretPlayer não está disponível');
        this.showToast('Player configuration not loaded', 'error');
        return;
      }

      // Buscar o vídeo na lista de vídeos em conversão
      // Tentar buscar por ID primeiro, depois por hash
      let videoConverting = this.videosConverting.find(
        (video: any) => Number(video.id) === Number(id),
      ) as any;

      // Se não encontrou por ID, tentar buscar por hash
      if (!videoConverting) {
        videoConverting = this.videosConverting.find((video: any) => video.hash === id) as any;
      }

      if (!videoConverting) {
        console.error(`Vídeo com ID/Hash ${id} não encontrado na lista de conversão`);
        console.log('Vídeos em conversão:', this.videosConverting);
        this.showToast('Video not found', 'error');
        return;
      }

      if (!videoConverting.hash) {
        console.error(`Hash do vídeo ${id} não encontrado`);
        this.showToast('Video hash not found', 'error');
        return;
      }

      let baseUrl;
      if (env === 'sandbox') {
        baseUrl = 'https://player-sandbox.jmvstream.com/';
      } else if (env === 'staging') {
        baseUrl = 'https://player-staging.jmvstream.com/';
      } else {
        baseUrl = 'https://player.jmvstream.com/';
      }

      const videoUrl = `${baseUrl}${this.secretPlayer}/${videoConverting.hash}`;

      // Garantir que autoplay tenha um valor válido
      const autoplayValue = videoConverting.autoplay === 1 || videoConverting.autoplay === true
        ? 'autoplay; fullscreen'
        : 'fullscreen';

      const iframeCode = String.prototype.concat(
        '<iframe ',
        `allow="${autoplayValue}" `,
        'allowfullscreen ',
        'class="jmvplayer" ',
        'frameborder="0" ',
        `src="${videoUrl}" `,
        'width="640" height="360"></iframe>',
      );

      console.log('Copiando iframe:', iframeCode);

      try {
        await Helpers.copyToClipboard(iframeCode);
        const index = this.videosConverting.findIndex(
          (video: any) => video.hash === videoConverting.hash,
        );
        if (index !== -1) {
          this.$set(this.videosConverting, index, {
            ...this.videosConverting[index],
            showCopySuccess: true,
          });
          setTimeout(() => {
            this.$set(this.videosConverting, index, {
              ...this.videosConverting[index],
              showCopySuccess: false,
            });
          }, 3000);
        }
        this.showToast('iframe_copied_successfully', 'success');
      } catch (err) {
        const error = err as Error;
        console.error(`Erro ao copiar para a área de transferência: ${error.message}`);
        this.showToast('error_copying_to_clipboard', 'error');
      }
    },
    async getPlanOd(eventId: number) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/event/getPlanOd/${eventId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });
        this.planOdId = response.data.customerPlansOdId;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async getGallerySelect() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/galleries/${this.planOdId}?`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });

        // Criar um mapa para armazenar as pastas com as informações necessárias
        const folderMap = new Map();

        // Primeiro, adicionar todas as pastas ao mapa
        response.data.galleries.forEach((gallery: any) => {
          folderMap.set(gallery.id, {
            id: gallery.id,
            name: gallery.name,
            parentId: gallery.parentId || null,
            type: 'folder',
            path: [], // Array para armazenar o caminho
          });
        });

        // Encontrar a pasta main (sem parentId)
        const mainFolder = Array.from(folderMap.values()).find((folder) => !folder.parentId);
        if (mainFolder) {
          this.folderMain = mainFolder;
        }

        // Construir os caminhos para cada pasta
        folderMap.forEach((folder) => {
          const path: string[] = [];

          // Construir o caminho recursivamente
          let { parentId } = folder;

          // Se a pasta tem um pai, adicionar os nomes dos pais ao caminho
          while (parentId) {
            const parentFolder = folderMap.get(parentId);
            if (parentFolder) {
              path.unshift(parentFolder.name);
              parentId = parentFolder.parentId;
            } else {
              break;
            }
          }

          // Atualizar o caminho da pasta
          // eslint-disable-next-line no-param-reassign
          folder.path = path;
          // eslint-disable-next-line no-param-reassign
          folder.fullPath = path.length > 0 ? `${path.join(' > ')} > ${folder.name}` : folder.name;
        });

        // Converter o mapa de volta para uma array e atualizar this.folders
        this.folders = Array.from(folderMap.values());

        // Inicializar a navegação com null (pasta raiz)
        if (!this.currentFolderParent) {
          this.currentFolderParent = null;
          this.folderStack = [];
        }
      } catch (error) {
        console.error('Erro ao carregar as pastas:', error);
      }
    },
    debounce(func: Function, key: string, delay: number) {
      // Limpa um timer existente para esta chave
      if (this.debounceTimers[key]) {
        clearTimeout(this.debounceTimers[key]!);
      }

      // Cria um novo timer
      this.debounceTimers[key] = window.setTimeout(() => {
        func();
        this.debounceTimers[key] = null;
      }, delay);
    },
    throttledGetAllVideos(forceUpdate = false) {
      const now = Date.now();
      // eslint-disable-next-line max-len
      const minInterval = forceUpdate ? 0 : 2000; // Se forceUpdate for true, ignorar o intervalo mínimo

      // Ignorar chamadas frequentes demais a menos que seja forceUpdate
      if (
        !forceUpdate
        && (this.isGetAllVideosRunning || now - this.lastGetAllVideosCall < minInterval)
      ) {
        return Promise.resolve();
      }

      this.lastGetAllVideosCall = now;
      this.isGetAllVideosRunning = true;

      return this.getAllVideos().finally(() => {
        this.isGetAllVideosRunning = false;
      });
    },
    navigateToFolder(folderId: number) {
      // Push the current parent to the stack
      this.folderStack.push(this.currentFolderParent);
      this.currentFolderParent = folderId;

      // Limpar a seleção atual de pasta ao navegar para uma subpasta
      this.selectedFolder = null;
    },
    navigateToParentFolder() {
      // Pop from the stack to go back
      if (this.folderStack.length > 0) {
        this.currentFolderParent = this.folderStack.pop();

        // Limpar a seleção atual de pasta ao retornar para a pasta pai
        this.selectedFolder = null;
      } else {
        this.currentFolderParent = null;
      }
    },
    hasSubfolders(folder: any) {
      // Verificar se existem pastas que têm esta pasta como pai
      return this.folders.some((item: any) => item.parentId === folder.id);
    },
    getFolderPathText(folder: any) {
      if (!folder) return '';

      // Build path by traversing parents
      const path = [];
      let currentParentId = folder.parentId;

      // Add the current folder
      path.unshift(folder.name);

      // Find all parent folders
      while (currentParentId) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-loop-func
        const parentFolder = this.folders.find((f: any) => f.id === currentParentId);
        if (parentFolder) {
          path.unshift(parentFolder.name);
          currentParentId = parentFolder.parentId;
        } else {
          break;
        }
      }

      return path.join(' > ');
    },
    removePendingVideo(index: number) {
      // Remove the video from the pending list
      const removedVideo = this.pendingVideos.splice(index, 1)[0];

      // Also remove from videoQueue if it exists there
      const queueIndex = this.videoQueue.findIndex((item) => item.file.name === removedVideo.name);
      if (queueIndex !== -1) {
        this.videoQueue.splice(queueIndex, 1);

        // Reduce the queue counter
        if (this.queueVideos > 0) {
          this.queueVideos -= 1;
        }
      }

      this.showToast('Video removed from queue', 'info');
    },
    // Método para buscar progresso do banco de dados
    async fetchVideoProgress(videoId: string) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/videos/progress/${videoId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });

        console.log('fetchVideoProgress - response.data', response.data);
        if (response.data && response.data.progress !== undefined) {
          const { progress, status, message } = response.data;

          // Atualizar progresso fluido com o novo valor real do backend
          this.updateSmoothProgress(videoId, progress);

          console.log(`Progresso real do banco - Video ${videoId}: ${progress}% (${status})`);
          return { progress, status, message };
        }
      } catch (error) {
        console.error(`Erro ao buscar progresso do vídeo ${videoId}:`, error);

        if ((error as any).response && (error as any).response.status === 404) {
          console.log(`Job ainda não criado para vídeo ${videoId}`);
          return null;
        }
      }
      return null;
    },

    // Método para buscar progresso de todos os vídeos em conversão
    async fetchAllVideosProgress() {
      try {
        const convertingVideos = this.videosConverting.map((video: any) => video.id);

        if (convertingVideos.length === 0) return;

        console.log(`Buscando progresso de ${convertingVideos.length} vídeos em conversão...`);

        const progressPromises = convertingVideos.map(async (videoId: any) => {
          try {
            return await this.fetchVideoProgress(videoId);
          } catch (error) {
            console.error(`Erro ao buscar progresso do vídeo ${videoId}:`, error);
            return null;
          }
        });

        const results = await Promise.all(progressPromises);
        const updatedCount = results.filter((result) => result !== null).length;

        console.log(`Progresso atualizado para ${updatedCount} vídeos`);
      } catch (error) {
        console.error('Erro ao buscar progresso de todos os vídeos:', error);
      }
    },

    // Inicia o progresso fluído com base no progresso inicial (real ou 0)
    startSmoothProgress(videoId: string, initialProgress = 0) {
      this.stopSmoothProgress(videoId);

      const safeProgress = Math.max(0, initialProgress);
      Vue.set(this.conversionsProgress, videoId, safeProgress);
      this.lastProgressUpdate[videoId] = safeProgress;

      this.startProgressInterpolation(videoId, safeProgress);
    },

    // Inicia interpolação baseada na duração estimada do vídeo
    startProgressInterpolation(videoId: string, currentProgress: number) {
      // Buscar informações do vídeo para estimar duração
      const video = this.uploadedVideos.find((v: any) => Number(v.id) === Number(videoId));

      let estimatedDuration = 300; // padrão 5 min para 360p (MAIS LENTO)

      if (video) {
        // Se temos a duração do vídeo, usar ela para estimar o tempo de conversão
        if (video.duration) {
          // Converter duração de "00:02:05.333" para segundos
          const durationInSeconds = this.parseVideoDuration(video.duration);

          // eslint-disable-next-line max-len
          // Para conversão 360p: MUITO MAIS LENTO - 2 minutos de conversão para cada 1 minuto de vídeo
          // Mínimo de 3 minutos, máximo de 15 minutos
          estimatedDuration = Math.max(180, Math.min(900, Math.ceil(durationInSeconds * 2)));
          console.log(
            `Estimativa baseada na duração real: ${video.duration} (${durationInSeconds}s) -> ${estimatedDuration}s de conversão`,
          );
        } else if (video.size) {
          // Fallback: se não temos duração, usar uma estimativa baseada no tamanho
          // Para 360p, conversão é mais lenta: 1 min por MB (MUITO MAIS LENTO)
          estimatedDuration = Math.max(
            180,
            Math.min(900, Math.ceil((video.size / (1024 * 1024)) * 1)),
          );
          console.log(
            `Estimativa baseada no tamanho: ${video.size} bytes -> ${estimatedDuration}s de conversão`,
          );
        }
      }

      this.estimatedConversionTime[videoId] = estimatedDuration;

      this.progressInterpolation[videoId] = {
        startProgress: currentProgress,
        startTime: Date.now(),
        estimatedDuration: this.estimatedConversionTime[videoId] * 1000,
        lastRealProgress: currentProgress,
        slowdownFactor: 1, // Inicializar fator de desaceleração em 1 (velocidade normal)
      };

      this.smoothProgressTimers[videoId] = window.setInterval(() => {
        this.updateSmoothProgress(videoId); // NÃO passar valor fixo!
      }, 200); // Atualizar menos frequentemente (200ms) para ser mais lento
    },

    // Função para converter duração do vídeo de "00:02:05.333" para segundos
    parseVideoDuration(duration: string): number {
      if (!duration) return 0;

      try {
        // Formato: "00:02:05.333" ou "02:05" ou "05"
        const parts = duration.split(':');
        let seconds = 0;

        if (parts.length === 3) {
          // Formato: "00:02:05.333"
          const hours = parseInt(parts[0], 10);
          const minutes = parseInt(parts[1], 10);
          const secondsPart = parseFloat(parts[2]);
          seconds = hours * 3600 + minutes * 60 + secondsPart;
        } else if (parts.length === 2) {
          // Formato: "02:05"
          const minutes = parseInt(parts[0], 10);
          const secondsPart = parseFloat(parts[1]);
          seconds = minutes * 60 + secondsPart;
        } else if (parts.length === 1) {
          // Formato: "05"
          seconds = parseFloat(parts[0]);
        }

        return Math.max(1, seconds); // Mínimo 1 segundo
      } catch (error) {
        console.error('Erro ao converter duração do vídeo:', duration, error);
        return 60; // Fallback para 1 minuto
      }
    },

    // Atualiza o progresso fluído com base na interpolação ou novo valor real
    updateSmoothProgress(videoId: string, newProgress?: number) {
      const interpolation = this.progressInterpolation[videoId];
      if (!interpolation) return;

      const currentProgress = this.conversionsProgress[videoId] || 0;

      // Se recebemos um novo progresso real do backend
      if (newProgress !== undefined) {
        // IMPORTANTE: NÃO permitir progresso regressivo
        // Se o backend reporta um valor menor que o atual, ignorar
        if (newProgress < currentProgress) {
          console.log(
            `Ignorando progresso regressivo: backend=${newProgress}%, frontend=${currentProgress}%`,
          );
          return;
        }

        // LÓGICA DE ADAPTAÇÃO DINÂMICA - MUITO MAIS AGRESSIVA
        const progressDifference = newProgress - currentProgress;

        // Se o frontend está à frente do backend (>10%), desacelerar DRASTICAMENTE
        if (progressDifference < -10) {
          console.log(
            `🔄 Frontend à frente (${Math.abs(
              progressDifference,
            )}%), desacelerando DRASTICAMENTE...`,
          );
          // Reduzir a velocidade da interpolação em 90% (MUITO MAIS LENTO)
          interpolation.slowdownFactor = (interpolation.slowdownFactor || 1) * 0.1;
          interpolation.slowdownFactor = Math.max(0.02, interpolation.slowdownFactor); // Mínimo 2%
        // eslint-disable-next-line brace-style
        }
        // Se o frontend está um pouco à frente (>5%), desacelerar bastante
        else if (progressDifference < -5) {
          console.log(
            `🔄 Frontend um pouco à frente (${Math.abs(
              progressDifference,
            )}%), desacelerando bastante...`,
          );
          // Reduzir a velocidade da interpolação em 70%
          interpolation.slowdownFactor = (interpolation.slowdownFactor || 1) * 0.3;
          interpolation.slowdownFactor = Math.max(0.05, interpolation.slowdownFactor); // Mínimo 5%
        // eslint-disable-next-line brace-style
        }
        // Se o backend está à frente (>5%), acelerar
        else if (progressDifference > 5) {
          console.log(`⚡ Backend à frente (${progressDifference}%), acelerando...`);
          // Aumentar a velocidade da interpolação em 50%
          interpolation.slowdownFactor = (interpolation.slowdownFactor || 1) * 1.5;
          interpolation.slowdownFactor = Math.min(2, interpolation.slowdownFactor); // Máximo 200%
        // eslint-disable-next-line brace-style
        }
        // Se a diferença é pequena, normalizar muito gradualmente
        else if (Math.abs(progressDifference) <= 2) {
          console.log(`✅ Diferença pequena (${progressDifference}%), normalizando...`);
          // Normalizar muito gradualmente para 1.0
          interpolation.slowdownFactor = (interpolation.slowdownFactor || 1) * 0.99;
          interpolation.slowdownFactor = Math.max(0.1, Math.min(1.2, interpolation.slowdownFactor));
        }

        // Se o novo progresso é maior que o último progresso real conhecido
        if (newProgress > interpolation.lastRealProgress) {
          // Atualizar o último progresso real conhecido
          interpolation.lastRealProgress = newProgress;

          // eslint-disable-next-line max-len
          // Se a diferença é significativa (>10%), acelerar suavemente para o novo valor (MAIS CONSERVADOR)
          if (newProgress > currentProgress + 10) {
            // Configurar uma transição suave para o novo valor
            interpolation.startProgress = currentProgress;
            interpolation.targetProgress = newProgress;
            interpolation.startTime = Date.now();
            // eslint-disable-next-line max-len
            interpolation.transitionDuration = 1200; // Aumentar para 1200ms para transição mais lenta

            // Calcular a velocidade de aceleração baseada na diferença (MAIS LENTA)
            const progressDifferences = newProgress - currentProgress;
            // eslint-disable-next-line max-len
            interpolation.accelerationRate = progressDifferences / 24; // 24 steps para transição mais lenta

            Vue.set(this.conversionsProgress, videoId, currentProgress);
            return;
          }
          // Se a diferença é pequena, atualizar normalmente mas nunca diminuir
          if (newProgress > currentProgress) {
            interpolation.startProgress = newProgress;
            interpolation.startTime = Date.now();
            Vue.set(this.conversionsProgress, videoId, newProgress);
          }
          return;
        }
      }

      // Se estamos em uma transição acelerada para um valor mais alto
      if (
        interpolation.targetProgress !== undefined
        && interpolation.accelerationRate !== undefined
      ) {
        const elapsed = Date.now() - interpolation.startTime;
        const transitionProgress = Math.min(elapsed / interpolation.transitionDuration, 1);

        // Usar uma função de easing para transição mais suave
        const easedProgress = this.easeOutCubic(transitionProgress);
        const currentTransitionValue = interpolation.startProgress
          + (interpolation.targetProgress - interpolation.startProgress) * easedProgress;

        // Aplicar a taxa de aceleração
        // eslint-disable-next-line max-len
        const acceleratedValue = currentTransitionValue + interpolation.accelerationRate * transitionProgress;

        const finalValue = Math.min(acceleratedValue, interpolation.targetProgress);
        Vue.set(this.conversionsProgress, videoId, Math.round(finalValue));

        // Se chegamos ao valor alvo, limpar a transição
        if (finalValue >= interpolation.targetProgress) {
          Vue.set(this.conversionsProgress, videoId, interpolation.targetProgress);
          interpolation.startProgress = interpolation.targetProgress;
          delete interpolation.targetProgress;
          delete interpolation.accelerationRate;
          delete interpolation.transitionDuration;
        }
        return;
      }

      // Interpolação normal quando não há transição acelerada
      const elapsed = Date.now() - interpolation.startTime;
      const progressRatio = elapsed / interpolation.estimatedDuration;

      // APLICAR FATOR DE DESACELERAÇÃO DINÂMICA - MUITO MAIS AGRESSIVO
      const slowdownFactor = interpolation.slowdownFactor || 1;
      const adjustedProgressRatio = progressRatio * slowdownFactor;

      // REDUZIR AINDA MAIS a velocidade da interpolação para ser super conservadora
      const interpolatedProgress = Math.min(
        interpolation.startProgress
          + adjustedProgressRatio * 0.3 * (100 - interpolation.startProgress), // 0.3 em vez de 0.5
        90, // Limitar a 90% em vez de 95% para ser ainda mais conservador
      );

      // IMPORTANTE: Nunca permitir que o progresso diminua
      const finalProgress = Math.max(
        currentProgress, // Nunca diminuir o progresso atual
        interpolation.lastRealProgress,
        Math.round(interpolatedProgress),
      );

      // Garantir que o progresso nunca diminua e seja suave
      const smoothProgress = Math.max(currentProgress, finalProgress);
      Vue.set(this.conversionsProgress, videoId, smoothProgress);
    },

    // Função de easing para transições mais suaves
    easeOutCubic(t: number): number {
      // eslint-disable-next-line no-restricted-properties
      return 1 - Math.pow(1 - t, 3);
    },

    // Para interpolação e limpa dados
    stopSmoothProgress(videoId: string) {
      if (this.smoothProgressTimers[videoId]) {
        clearInterval(this.smoothProgressTimers[videoId]);
        delete this.smoothProgressTimers[videoId];
      }

      if (this.progressInterpolation[videoId]) {
        delete this.progressInterpolation[videoId];
      }
    },

    // Iniciar sistema de watching
    startWatching() {
      if (this.isWatchingRunning) {
        console.log('Watching já está rodando');
        return;
      }

      console.log('🔄 Iniciando sistema de watching por hash...');
      this.isWatchingRunning = true;

      // Agora apenas monitoramos os hashes dos vídeos que acabaram de fazer upload
      // Não buscamos mais todos os vídeos do plano
      this.watchingInterval = setInterval(async () => {
        try {
          // Monitorar apenas os hashes que temos
          if (this.videoHashesToMonitor.length > 0) {
            console.log(`🔍 Monitorando ${this.videoHashesToMonitor.length} vídeos por hash...`);
            await this.monitorVideoStatus(this.videoHashesToMonitor);
          }
        } catch (error) {
          console.error('Erro no watching por hash:', error);
        }
      }, this.watchingInterval);
    },

    stopWatching() {
      if (this.watchingTimer) {
        clearInterval(this.watchingTimer);
        this.watchingTimer = null;
      }
      this.isWatchingRunning = false;
      console.log('Sistema de watching parado');
    },

    // Método para verificar vídeos em conversão
    async watchConversionVideos() {
      // REMOVIDO: Não vamos mais buscar todos os vídeos do plano
      // Agora usamos apenas monitoramento por hash dos vídeos que acabaram de fazer upload
      console.log('🔄 Sistema de watching desabilitado - usando apenas monitoramento por hash');
    },

    // eslint-disable-next-line max-len
    checkStatusChanges(
      awaitConversionVideos: any[],
      convertingVideos: any[],
      completedVideos: any[],
    ) {
      // Verificar se há novos vídeos aguardando conversão
      const newAwaitConversion = awaitConversionVideos.filter(
        // eslint-disable-next-line max-len
        (video: any) => !this.videosAwaitConversion.some((existing: any) => existing.id === video.video_id),
      );

      // Verificar se há novos vídeos em conversão
      const newConverting = convertingVideos.filter(
        // eslint-disable-next-line max-len
        (video: any) => !this.videosConverting.some((existing: any) => existing.id === video.video_id),
      );

      // Verificar se há novos vídeos completados
      const newCompleted = completedVideos.filter(
        // eslint-disable-next-line max-len
        (video: any) => !this.videosConverted.some((existing: any) => existing.id === video.video_id),
      );

      // Verificar se há vídeos que saíram da lista de aguardando conversão
      const removedFromAwait = this.videosAwaitConversion.filter(
        // eslint-disable-next-line max-len
        (existing: any) => !awaitConversionVideos.some((video: any) => video.video_id === existing.id),
      );

      // Verificar se há vídeos que saíram da lista de conversão
      const removedFromConverting = this.videosConverting.filter(
        (existing: any) => !convertingVideos.some((video: any) => video.video_id === existing.id),
      );

      // Log das mudanças
      if (newAwaitConversion.length > 0) {
        console.log(`🆕 Novos vídeos aguardando conversão: ${newAwaitConversion.length}`);
      }

      if (newConverting.length > 0) {
        console.log(`🔄 Novos vídeos em conversão: ${newConverting.length}`);
      }

      if (newCompleted.length > 0) {
        console.log(`✅ Novos vídeos completados: ${newCompleted.length}`);
      }

      if (removedFromAwait.length > 0) {
        console.log(`➡️ Vídeos que saíram de aguardando conversão: ${removedFromAwait.length}`);
      }

      if (removedFromConverting.length > 0) {
        console.log(`✅ Vídeos que saíram de conversão: ${removedFromConverting.length}`);
      }

      // Atualizar as listas
      this.updateVideoLists(
        newAwaitConversion,
        newConverting,
        newCompleted,
        removedFromAwait,
        removedFromConverting,
      );
    },

    updateVideoLists(
      newAwait: any[],
      newConverting: any[],
      newCompleted: any[],
      removedAwait: any[],
      removedConverting: any[],
    ) {
      // Remover vídeos que saíram das listas
      this.videosAwaitConversion = this.videosAwaitConversion.filter(
        (video: any) => !removedAwait.some((removed: any) => removed.id === video.id),
      );

      this.videosConverting = this.videosConverting.filter(
        (video: any) => !removedConverting.some((removed: any) => removed.id === video.id),
      );

      // Adicionar novos vídeos
      newAwait.forEach((video: any) => {
        const videoData = {
          id: video.video_id,
          name: video.video_name,
          hash: video.video_hash,
          status: 'AWAIT_CONVERSION',
          progress: 0,
          progressConverting: 0,
          autoplay: video.autoplay || 0,
        };
        this.videosAwaitConversion.push(videoData);
      });

      newConverting.forEach((video: any) => {
        const videoData = {
          id: video.video_id,
          name: video.video_name,
          hash: video.video_hash,
          status: 'CONVERTING',
          progress: 100,
          progressConverting: video.progress || 0,
          autoplay: video.autoplay || 0,
        };
        this.videosConverting.push(videoData);

        // Iniciar progresso fluído para novos vídeos em conversão
        this.startSmoothProgress(video.video_id, video.progress || 0);
      });

      newCompleted.forEach((video: any) => {
        const videoData = {
          id: video.video_id,
          name: video.video_name,
          hash: video.video_hash,
          status: 'COMPLETED',
          progress: 100,
          progressConverting: 100,
          autoplay: video.autoplay || 0,
        };
        this.videosConverted.push(videoData);
      });

      // Verificar se há vídeos que mudaram de status
      this.checkStatusChanges(newAwait, newConverting, newCompleted);
    },

    // Método para reiniciar o watching
    restartWatching() {
      console.log('Reiniciando sistema de watching...');
      this.stopWatching();
      setTimeout(() => {
        this.startWatching();
      }, 1000);
    },

    // Método para verificar se o watching está ativo
    isWatchingActive() {
      return this.isWatchingRunning && this.watchingTimer !== null;
    },

    // Método para ajustar o intervalo do watching
    setWatchingInterval(interval: number) {
      this.watchingInterval = interval;
      if (this.isWatchingActive()) {
        this.restartWatching();
      }
    },
    // Método para monitorar status de vídeos específicos por hash
    async monitorVideoStatus(videoHashes: string[]) {
      try {
        console.log(`🔍 Monitorando status de ${videoHashes.length} vídeos`);

        const results = await Promise.all(
          videoHashes.map(async (hash) => {
            const status = await this.getVideoJobStatus(hash);
            return {
              hash,
              ...status,
            };
          }),
        );

        // Processar resultados
        results.forEach((result) => {
          console.log('result', result);
          if (result.success) {
            // Deixar a lógica de aceleração suave lidar com as atualizações de progresso
            this.updateVideoStatusByHash(
              result.hash,
              result.status,
              result.progress,
              result.message,
              result.videoData, // Passar os dados do vídeo do backend
            );
          }
        });

        return results;
      } catch (error) {
        console.error('Erro ao monitorar status dos vídeos:', error);
        return [];
      }
    },

    // Método para atualizar status de vídeo por hash
    updateVideoStatusByHash(
      hash: string,
      status: string,
      progress: number,
      message: string,
      backendVideoData?: any,
    ) {
      // Encontrar vídeo na lista de vídeos aguardando conversão
      const awaitIndex = this.videosAwaitConversion.findIndex((v: any) => v.hash === hash);
      if (awaitIndex !== -1) {
        const video = this.videosAwaitConversion[awaitIndex];
        video.status = status;
        video.progressConverting = progress;
        video.message = message;

        // Se o vídeo começou a converter, mover para lista de conversão
        if (status === 'CONVERTING') {
          this.videosAwaitConversion.splice(awaitIndex, 1);
          this.videosConverting.push(video);

          // Parar interpolação anterior e iniciar com progresso real do backend
          this.stopSmoothProgress(video.id);

          // Se o progresso do backend é 0, começar do 0
          const initialProgress = progress === 0 ? 0 : progress;
          this.startSmoothProgress(video.id, initialProgress);

          // Usar progresso real do backend imediatamente
          Vue.set(this.conversionsProgress, video.id, initialProgress);
        }

        // Se o vídeo foi completado, mover para lista de completados
        if (status === 'COMPLETED') {
          this.videosAwaitConversion.splice(awaitIndex, 1);
          this.videosConverted.push(video);
        }

        return;
      }

      // Encontrar vídeo na lista de vídeos em conversão
      const convertingIndex = this.videosConverting.findIndex((v: any) => v.hash === hash);
      if (convertingIndex !== -1) {
        const video = this.videosConverting[convertingIndex];
        video.status = status;
        video.progressConverting = progress;
        video.message = message;

        // Usar a nova lógica de aceleração suave em vez de aplicar imediatamente
        if (this.progressInterpolation[video.id]) {
          // Atualizar o progresso usando a lógica de aceleração suave
          this.updateSmoothProgress(video.id, progress);
        }

        // Se o vídeo foi completado, mover para lista de completados
        if (status === 'COMPLETED') {
          this.videosConverting.splice(convertingIndex, 1);
          this.videosConverted.push(video);
        }

        return;
      }

      // Se não encontrou em nenhuma lista, adicionar na lista apropriada
      const newVideoData = {
        id: hash, // Usar hash como ID temporário
        name: backendVideoData?.name || `Vídeo ${hash.substring(0, 8)}...`, // Usar nome do backend se disponível
        hash,
        status,
        progress: 100,
        progressConverting: progress,
        message,
        // eslint-disable-next-line max-len
        autoplay: backendVideoData?.autoplay === 1 || backendVideoData?.autoplay === true ? 1 : 0, // Garantir valor padrão
        created_date: new Date().toISOString(), // Adicionar data de criação
        duration: backendVideoData?.duration || null, // Usar duração real do backend
      };

      if (status === 'AWAIT_CONVERSION') {
        this.videosAwaitConversion.push(newVideoData);
      } else if (status === 'CONVERTING') {
        this.videosConverting.push(newVideoData);

        // Parar interpolação anterior e iniciar com progresso real do backend
        this.stopSmoothProgress(newVideoData.id);

        // Se o progresso do backend é 0, começar do 0
        const initialProgress = progress === 0 ? 0 : progress;
        this.startSmoothProgress(newVideoData.id, initialProgress);

        // Usar progresso real do backend imediatamente
        Vue.set(this.conversionsProgress, newVideoData.id, initialProgress);
      } else if (status === 'COMPLETED') {
        this.videosConverted.push(newVideoData);
      }
    },

    // Método para iniciar monitoramento do status do vídeo
    startVideoStatusMonitoring(videoHash: string) {
      console.log(`🔍 Iniciando monitoramento do vídeo: ${videoHash}`);

      // Verificar status imediatamente
      this.checkVideoStatus(videoHash);

      // Configurar intervalo para verificar status a cada 5 segundos
      const intervalId = setInterval(async () => {
        const status = await this.getVideoJobStatus(videoHash);
        console.log('intervalId - status', status);

        if (status.success) {
          this.updateVideoStatusByHash(
            videoHash,
            status.status,
            status.progress,
            status.message,
            status.videoData,
          );

          // Se o vídeo foi completado ou teve erro, parar o monitoramento
          if (status.status === 'COMPLETED' || status.status === 'ERROR') {
            console.log(`✅ Monitoramento finalizado para vídeo ${videoHash}: ${status.status}`);
            clearInterval(intervalId);

            // Remover hash da lista de monitoramento
            const index = this.videoHashesToMonitor.indexOf(videoHash);
            if (index > -1) {
              this.videoHashesToMonitor.splice(index, 1);
            }
          }
        }
      }, 5000); // Verificar a cada 5 segundos

      // Armazenar o intervalId para poder cancelar se necessário
      this.videoMonitoringIntervals = this.videoMonitoringIntervals || {};
      this.videoMonitoringIntervals[videoHash] = intervalId;
    },

    // Método para verificar status do vídeo uma vez
    async checkVideoStatus(videoHash: string) {
      const status = await this.getVideoJobStatus(videoHash);
      console.log('checkVideoStatus - status', status);
      if (status.success) {
        // Deixar a lógica de aceleração suave lidar com as atualizações de progresso
        this.updateVideoStatusByHash(
          videoHash,
          status.status,
          status.progress,
          status.message,
          status.videoData,
        );
      }
    },

    // Método para parar monitoramento de um vídeo específico
    stopVideoStatusMonitoring(videoHash: string) {
      if (this.videoMonitoringIntervals && this.videoMonitoringIntervals[videoHash]) {
        clearInterval(this.videoMonitoringIntervals[videoHash]);
        delete this.videoMonitoringIntervals[videoHash];
        console.log(`🛑 Monitoramento parado para vídeo: ${videoHash}`);
      }
    },

    // Método para parar todos os monitoramentos
    stopAllVideoStatusMonitoring() {
      if (this.videoMonitoringIntervals) {
        Object.keys(this.videoMonitoringIntervals).forEach((hash) => {
          clearInterval(this.videoMonitoringIntervals[hash]);
        });
        this.videoMonitoringIntervals = {};
        this.videoHashesToMonitor = [];
        console.log('🛑 Todos os monitoramentos parados');
      }
    },

    // Método para buscar status do job por hash do vídeo
    async getVideoJobStatus(videoHash: string) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/videos/job-status/${videoHash}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });

        if (response.data && response.data.success) {
          const {
            progress, status, message, jobData, videoData,
          } = response.data;
          console.log(`Status do job para vídeo ${videoHash}:`, {
            progress,
            status,
            message,
            jobData,
            videoData,
          });

          return {
            success: true,
            progress,
            status,
            message,
            jobData,
            videoData,
          };
        }
      } catch (error) {
        console.error(`Erro ao buscar status do job para vídeo ${videoHash}:`, error);

        // Se o job não foi encontrado (404), retornar status AWAIT_CONVERSION
        if (error.response && error.response.status === 404) {
          return {
            success: true,
            progress: 0,
            status: 'AWAIT_CONVERSION',
            message: 'Aguardando início da conversão',
            jobData: null,
            videoData: null,
          };
        }
      }

      return {
        success: false,
        progress: 0,
        status: 'ERROR',
        message: 'Erro ao buscar status do job',
        jobData: null,
        videoData: null,
      };
    },
    // Método para buscar todos os vídeos do plano que estão convertendo
    async getAllConvertingVideosForPlan() {
      try {
        console.log('🔍 Buscando todos os vídeos convertendo do plano...');

        const apiUrl = process.env.VUE_APP_API_URL;

        // Buscar todos os vídeos em conversão do plano
        const response = await axios.get(`${apiUrl}/videos/converting-today/${this.planOdId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });

        if (response.data && response.data.success) {
          const convertingVideos = response.data.videos || [];
          console.log(`✅ Encontrados ${convertingVideos.length} vídeos convertendo no plano`);
          console.log('📊 Dados dos vídeos:', convertingVideos);

          // Processar cada vídeo encontrado
          convertingVideos.forEach((videoData: any) => {
            const videoHash = videoData.video_hash || videoData.hash;

            if (videoHash) {
              // Adicionar à lista de hashes para monitoramento
              if (!this.videoHashesToMonitor.includes(videoHash)) {
                this.videoHashesToMonitor.push(videoHash);
              }

              // Criar objeto de vídeo para a interface
              const videoObject = {
                id: videoData.video_id || videoData.customer_plans_videos_id || videoHash,
                name: videoData.video_name || `Vídeo ${videoHash.substring(0, 8)}...`,
                hash: videoHash,
                status: videoData.status?.toUpperCase() || 'CONVERTING',
                progress: 100,
                progressConverting: videoData.progress || 0,
                message: videoData.message || 'Convertendo...',
                autoplay: videoData.video_autoplay || 0,
                created_date:
                  videoData.video_created_at || videoData.created_at || new Date().toISOString(),
                duration: videoData.video_duration || null, // Usar duração real do backend
              };

              console.log('📝 Processando vídeo:', videoObject);

              // Adicionar à lista apropriada baseado no status
              if (videoData.status === 'pending') {
                // Verificar se já não está na lista
                const exists = this.videosAwaitConversion.some((v: any) => v.hash === videoHash);
                if (!exists) {
                  this.videosAwaitConversion.push(videoObject);
                  console.log('✅ Adicionado à lista de aguardando conversão');
                }
              } else if (videoData.status === 'processing' || videoData.status === 'converting') {
                // Verificar se já não está na lista
                const exists = this.videosConverting.some((v: any) => v.hash === videoHash);
                if (!exists) {
                  this.videosConverting.push(videoObject);
                  console.log('✅ Adicionado à lista de convertendo');

                  // Iniciar monitoramento do progresso
                  this.startVideoStatusMonitoring(videoHash);

                  // Iniciar interpolação suave se necessário
                  if (videoObject.progressConverting >= 0) {
                    this.startProgressInterpolation(videoObject.id, videoObject.progressConverting);
                  }
                }
              } else if (videoData.status === 'completed') {
                // Verificar se já não está na lista
                const exists = this.videosConverted.some((v: any) => v.hash === videoHash);
                if (!exists) {
                  this.videosConverted.push(videoObject);
                  console.log('✅ Adicionado à lista de completados');
                }
              }
            }
          });

          console.log(
            `📊 Status atual: ${this.videosAwaitConversion.length} aguardando, ${this.videosConverting.length} convertendo, ${this.videosConverted.length} completados`,
          );
        }
      } catch (error) {
        console.error('❌ Erro ao buscar vídeos convertendo do plano:', error);
      }
    },
  },
});
